import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { sortedStories, fmtDate } from "../data/impactStories";

// Reusable anywhere: pulls the newest approved featured Impact Story automatically.
export const LatestImpactStory = () => {
  const story = sortedStories.find((s) => s.featured) || sortedStories[0];
  if (!story) return null;

  return (
    <section data-testid="latest-impact-story" className="py-14 bg-[#08080a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Link
          to={`/esg?story=${story.id}`}
          data-testid="latest-impact-story-link"
          className="reveal group relative block rounded-2xl overflow-hidden border border-white/10 hover:border-[#F5D000]/50 transition-all"
        >
          <div className="grid grid-cols-1 md:grid-cols-12">
            <div className="relative md:col-span-4 h-52 md:h-auto overflow-hidden">
              <img src={story.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0e0e12]/60 hidden md:block" />
            </div>
            <div className="md:col-span-8 bg-[#0e0e12] p-7 lg:p-9 flex flex-col justify-center">
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#F5D000] text-black text-[9px] uppercase tracking-[0.2em] font-bold">
                  <Sparkles className="w-3 h-3" /> Latest Impact Story
                </span>
                <span className="text-[11px] text-white/45">{fmtDate(story.date)} · {story.categories.join(" · ")}</span>
              </div>
              <h3 className="font-display text-xl lg:text-2xl font-bold text-white leading-snug mb-2">{story.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed line-clamp-2 max-w-2xl mb-4">{story.summary}</p>
              <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#F5D000] group-hover:gap-3.5 transition-all">
                Read inside Responsible Infrastructure <ArrowUpRight className="w-3.5 h-3.5" />
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};
